import {BaseCachedService} from './Core/BaseCachedService';

class SurveyTypeService extends BaseCachedService {
    get Url() { return super.Url + "/surveyTypes"; }
    get ModelName() { return "Survey Type"; }
    get PrimaryKeyProperty() { return "surveyTypeId"; }
    get TitleProperty() { return "name"; }
}

export const service = new SurveyTypeService();

